<template>
  <div class="menubar">
    <div class="title">colorinco</div>
    <div class="logobox">
      <img class="logo" src="/static/inco.svg" width="40" height="40">
    </div>
    <div class="items">
      <menu-item @click="onBtnMyimgs" :class="{active: active === 'myimgs'}">MY</menu-item>
      <menu-item @click="onBtnFavs" :class="{active: active === 'favs'}">FAV</menu-item>
      <menu-item @click="onBtnStocks" :class="{active: active === 'stocks'}">STOCK</menu-item>
    </div>
    <div class="more"><div class="icon"
      :class="{active: showMore}"
      @click="toggleMore"
    ></div></div>
    <ul class="more-list" :class="{active: showMore}">
      <li @click="onLogout">Logout</li>
    </ul>
  </div>
</template>

<style scoped>
.menubar {
  width: 100%;
  height: 40px;
  top: 0;
  left: 0;
  background: white;
  border-bottom: 1px solid #aaa;
  position: absolute;
  z-index: 1001;

}
.title {
  font-size: 14pt;
  text-align: left;
  line-height: 40px;
  width: 50%;
  display: inline-block;
  position: absolute;
  left: 45px;
  top: 8px;
  color: #555;
}
.logobox {
  position: absolute;
  left: 4px;
  top: 7px;
  width: 40px;
  height: 32px;
  overflow-y: hidden;
}
.logo {
  opacity: 0.8;
}
.items {
  position: absolute;
  width: 50%;
  height: 40px;
  right: 40px;
  text-align: right;
}
.active {
  border-bottom: 3px solid #aaa;
}
.more {
  position: absolute;
  width: 25px;
  height: 40px;
  right: 5px;
}
.more .icon {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 10px;
  top: 8px;
  border-bottom: 2px solid #aaa;
  border-right: 2px solid #aaa;
  transform: rotate(45deg);
  transition: transform 300ms 0.15s cubic-bezier(.41,.8,.67,1);
}
.more .icon.active {
  transform: rotate(-135deg);
}
.more-list {
  position: absolute;
  z-index: -1;
  top: calc(40px - 1px);
  height: 0;
  right: -1px;
  overflow: hidden;
  width: 150px;
  background: white;
  border: 1px solid #aaa;
  border-bottom-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  transition: all 200ms 0.15s cubic-bezier(.41,.8,.67,1);
}
.more-list.active {
  height: 60px;
  border-bottom-width: 1px;
  /* box-shadow: 0px 0px 33px 0px #333; */
}
.more-list li{
  margin: 4px 10px 4px 10px;
  padding: 5px 10px;
  text-align: left;
  font-size: 10pt;
  color: gray;
}
</style>

<script>
import UserApi from '@/api/UserApi'
import MenuItem from '@/components/MenuItem'
import * as atypes from '@/store/action-types'
export default {
  name: 'Menubar',
  components: {MenuItem},
  data () {
    return {
      showMore: false
    }
  },
  computed: {
    listType () { return this.$store.state.TweetListPage.listType },
    active () { return this.listType }
  },
  methods: {
    onBtnMyimgs () {
      this.$router.push('/myimgs')
    },
    onBtnFavs () {
      this.$router.push('/favs')
    },
    onBtnStocks () {
      this.$router.push('/stocks')
    },
    toggleMore () {
      this.$data.showMore = !this.$data.showMore
    },
    onLogout () {
      UserApi.logout().then(() => {
        this.$store.dispatch(atypes.FLASH_SET_MSG, {msg: 'LOGGED OUT'})
        this.$router.push('/login')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menubar.vue